module.exports = __webpack_public_path__ + "static/media/health_bgimage.e91a44de.png";